<template>
  <div id="warehouse-general-settings-container">
    <el-form
      :model="editForm"
      :rules="editFormRules"
      ref="editForm"
      size="mini"
      class="search-section-form"
    >
      <el-row :gutter="10">
        <el-col :span="3" class="list-name" v-show="!warehouse.isEditingSettings">
          <label class="margin-bottom-small-list">{{ $t('warehouse.settings.labelCode') }}</label>
        </el-col>
        <el-col :span="5" class="list-name" v-show="!warehouse.isEditingSettings">
          <span class="span-small-list">{{ warehouse.detail.code }}</span>
        </el-col>
        <el-col :span="8" v-show="warehouse.isEditingSettings">
          <el-form-item :label="$t('warehouse.settings.labelCode')">
            <el-input :value="warehouse.detail.code" :readonly="true" :disabled="true"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="3" class="list-name" v-show="!warehouse.isEditingSettings">
          <label class="margin-bottom-small-list">{{ $t('warehouse.settings.labelName') }}</label>
        </el-col>
        <el-col :span="5" class="list-name" v-show="!warehouse.isEditingSettings">
          <span class="span-small-list">{{ warehouse.detail.name }}</span>
        </el-col>
        <el-col :span="8" v-show="warehouse.isEditingSettings">
          <el-form-item :label="$t('warehouse.settings.labelName')" prop="name">
            <el-input v-model="editForm.name" clearable maxlength="50"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="3" class="list-name" v-show="!warehouse.isEditingSettings">
          <label class="margin-bottom-small-list">{{ $t('warehouse.settings.labelRegion') }}</label>
        </el-col>
        <el-col :span="5" class="list-name" v-show="!warehouse.isEditingSettings">
          <span class="span-small-list">{{ warehouse.detail.regionName }}</span>
        </el-col>
        <el-col :span="8" v-show="warehouse.isEditingSettings">
          <el-form-item :label="$t('warehouse.settings.labelRegion')">
            <el-input :value="warehouse.detail.regionName" :readonly="true" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="3" class="list-name" v-show="!warehouse.isEditingSettings">
          <label class="margin-bottom-small-list">{{ $t('warehouse.settings.labelIsTerminal') }}</label>
        </el-col>
        <el-col :span="5" class="list-name" v-show="!warehouse.isEditingSettings">
          <span class="span-small-list">{{ warehouse.detail.terminal ? yes.label : no.label }}</span>
        </el-col>
        <el-col :span="8" v-show="warehouse.isEditingSettings">
          <el-form-item :label="$t('warehouse.settings.labelIsTerminal')">
            <el-select v-model="editForm.terminal">
              <el-option :label="yes.label" :value="yes.value"></el-option>
              <el-option :label="no.label" :value="no.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="3" class="list-name" v-show="!warehouse.isEditingSettings">
          <label
            class="margin-bottom-small-list"
          >{{ $t('warehouse.settings.labelExtensionsEmail') }}</label>
        </el-col>
        <el-col :span="5" class="list-name" v-show="!warehouse.isEditingSettings">
          <span class="span-small-list">{{ warehouse.detail.emailExtension }}</span>
        </el-col>
        <el-col :span="8" v-show="warehouse.isEditingSettings">
          <el-form-item
            :label="$t('warehouse.settings.labelExtensionsEmail')"
            prop="emailExtension"
            class="warehouse-general-settings-label"
          >
            <el-input v-model="editForm.emailExtension" clearable maxlength="100"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="3" class="list-name" v-show="!warehouse.isEditingSettings">
          <label
            class="margin-bottom-small-list"
          >{{ $t('warehouse.settings.labelExtensionCutoffSurcharge') }}</label>
        </el-col>
        <el-col :span="5" class="list-name" v-show="!warehouse.isEditingSettings">
          <span class="span-small-list">{{ warehouse.detail.extensionCutoffSurcharge }}</span>
        </el-col>
        <el-col :span="8" v-show="warehouse.isEditingSettings">
          <el-form-item
            :label="$t('warehouse.settings.labelExtensionCutoffSurcharge')"
            prop="extensionCutoffSurcharge"
            class="warehouse-general-settings-label"
          >
            <el-time-select
              clearable
              v-model="editForm.extensionCutoffSurcharge"
              :picker-options="datePickerHourOptions"
            ></el-time-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="3" class="list-name" v-show="!warehouse.isEditingSettings">
          <label
            class="margin-bottom-small-list"
          >{{ $t('warehouse.settings.labelDefaultProductCode') }}</label>
        </el-col>
        <el-col :span="5" class="list-name" v-show="!warehouse.isEditingSettings">
          <span class="span-small-list">{{ warehouse.detail.defaultProductCode }}</span>
        </el-col>
        <el-col :span="8" v-show="warehouse.isEditingSettings">
          <el-form-item
            :label="$t('warehouse.settings.labelDefaultProductCode')"
            class="warehouse-general-settings-label"
          >
            <el-input v-model="editForm.defaultProductCode" clearable maxlength="255"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="3" class="list-name" v-show="!warehouse.isEditingSettings">
          <label
            class="margin-bottom-small-list"
          >{{ $t('warehouse.settings.labelDefaultProductDescription') }}</label>
        </el-col>
        <el-col :span="5" class="list-name" v-show="!warehouse.isEditingSettings">
          <span class="span-small-list">{{ warehouse.detail.defaultProductDescription }}</span>
        </el-col>
        <el-col :span="8" v-show="warehouse.isEditingSettings">
          <el-form-item
            :label="$t('warehouse.settings.labelDefaultProductDescription')"
            class="warehouse-general-settings-label"
          >
            <el-input v-model="editForm.defaultProductDescription" clearable maxlength="255"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="3" class="list-name" v-show="!warehouse.isEditingSettings">
          <label
            class="margin-bottom-small-list"
          >{{ $t('warehouse.settings.labelAllowSameDayShipments') }}</label>
        </el-col>
        <el-col :span="5" class="list-name" v-show="!warehouse.isEditingSettings">
          <span
            class="span-small-list"
          >{{ warehouse.detail.allowSameDayShipments ? yes.label : no.label }}</span>
        </el-col>
        <el-col :span="8" v-show="warehouse.isEditingSettings">
          <el-form-item
            :label="$t('warehouse.settings.labelAllowSameDayShipments')"
            class="warehouse-general-settings-label"
          >
            <el-select v-model="editForm.allowSameDayShipments">
              <el-option :label="yes.label" :value="yes.value"></el-option>
              <el-option :label="no.label" :value="no.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="3" class="list-name" v-show="!warehouse.isEditingSettings">
          <label
            class="margin-bottom-small-list"
          >{{ $t('warehouse.settings.labelPalletExchange') }}</label>
        </el-col>
        <el-col :span="5" class="list-name" v-show="!warehouse.isEditingSettings">
          <span
            class="span-small-list"
          >{{ warehouse.detail.palletExchange ? yes.label : no.label }}</span>
        </el-col>
        <el-col :span="8" v-show="warehouse.isEditingSettings">
          <el-form-item
            :label="$t('warehouse.settings.labelPalletExchange')"
            class="warehouse-general-settings-label"
          >
            <el-select v-model="editForm.palletExchange">
              <el-option :label="yes.label" :value="yes.value"></el-option>
              <el-option :label="no.label" :value="no.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3" class="list-name" v-show="!warehouse.isEditingSettings">
          <label class="margin-bottom-small-list">{{ $t('warehouse.settings.labelStatus') }}</label>
        </el-col>
        <el-col :span="5" class="list-name" v-show="!warehouse.isEditingSettings">
          <span class="span-small-list">{{ warehouse.detail.status ? activeLabel : inactiveLabel }}</span>
        </el-col>
        <el-col :span="8" v-show="warehouse.isEditingSettings">
          <el-form-item :label="$t('warehouse.settings.labelStatus')">
            <el-input
              :value="warehouse.detail.status ? activeLabel : inactiveLabel"
              :readonly="true"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3" class="list-name" v-show="!warehouse.isEditingSettings">
          <label
            class="margin-bottom-small-list"
          >{{ $t('warehouse.settings.labelReleaseEmail') }}</label>
        </el-col>
        <el-col :span="5" class="list-name" v-show="!warehouse.isEditingSettings">
          <span
            class="span-small-list"
          >{{ warehouse.detail.releaseEmail }}</span>
        </el-col>
        <el-col :span="8" v-show="warehouse.isEditingSettings">
          <el-form-item
            :label="$t('warehouse.settings.labelReleaseEmail')"
            prop="releaseEmail"
            class="warehouse-general-settings-label"
          >
            <el-input v-model="editForm.releaseEmail" clearable maxlength="100"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3" class="list-name" v-show="!warehouse.isEditingSettings">
          <label
            class="margin-bottom-small-list"
          >{{ $t('warehouse.settings.labelEtcEmail') }}</label>
        </el-col>
        <el-col :span="5" class="list-name" v-show="!warehouse.isEditingSettings">
          <span
            class="span-small-list"
          >{{ warehouse.detail.etcEmail }}</span>
        </el-col>
        <el-col :span="8" v-show="warehouse.isEditingSettings">
          <el-form-item
            :label="$t('warehouse.settings.labelEtcEmail')"
            prop="etcEmail"
            class="warehouse-general-settings-label"
          >
            <el-input v-model="editForm.etcEmail" clearable maxlength="100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16" class="text-align-end" v-show="warehouse.isEditingSettings">
          <div id="general-settings-form-actions" class="reverse-form-actions">
            <el-button
              type="primary"
              id="form-save-button"
              @click="submitForm()"
              size="mini"
            >{{ $t('common.save') }}</el-button>
            <el-button
              id="form-refresh-button"
              @click="cancelEditSettings()"
              size="mini"
            >{{ $t('common.cancel') }}</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { Message } from 'element-ui';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';

export default {
  name: 'generalWarehouseSettings',
  computed: {
    ...mapGetters(['warehouse'])
  },
  data() {
    return {
      activeLabel: constants.STATUS_BOOLEAN.active.label,
      inactiveLabel: constants.STATUS_BOOLEAN.inactive.label,
      yes: constants.STATUS_BOOLEAN.yes,
      no: constants.STATUS_BOOLEAN.no,
      editForm: {
        name: null,
        terminal: null,
        emailExtension: null,
        extensionCutoffSurcharge: null,
        defaultProductCode: null,
        defaultProductDescription: null,
        allowSameDayShipments: null,
        palletExchange: null,
        releaseEmail: null,
        etcEmail: null
      },
      editFormRules: {
        emailExtension: [
          {
            required: true,
            message: this.$t('warehouse.settings.error.emailRequired'),
            trigger: 'blur'
          },
          {
            type: 'email',
            message: this.$t('warehouse.settings.error.emailValid'),
            trigger: 'blur'
          }
        ],
        releaseEmail: [
          {
            required: true,
            message: this.$t('warehouse.settings.error.emailRequired'),
            trigger: 'blur'
          },
          {
            type: 'email',
            message: this.$t('warehouse.settings.error.emailValid'),
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('warehouse.settings.error.nameRequired'),
            trigger: 'blur'
          }
        ],
        extensionCutoffSurcharge: [
          {
            required: true,
            message: this.$t(
              'warehouse.settings.error.extensionCutoffSurchargeRequired'
            ),
            trigger: 'blur'
          }
        ],
        etcEmail: [
          {
            required: true,
            message: this.$t('warehouse.settings.error.etcEmailRequired'),
            trigger: 'blur'
          },
          {
            type: 'email',
            message: this.$t('warehouse.settings.error.emailValid'),
            trigger: 'blur'
          }
        ]
      },
      datePickerHourOptions: {
        step: '00:30',
        start: '00:00',
        end: '23:59'
      }
    };
  },
  methods: {
    resetForm() {
      this.$refs.editForm.resetFields();
      this.editForm.name = this.warehouse.detail.name;
      this.editForm.terminal = this.warehouse.detail.terminal;
      this.editForm.emailExtension = this.warehouse.detail.emailExtension;
      this.editForm.extensionCutoffSurcharge = this.warehouse.detail.extensionCutoffSurcharge;
      this.editForm.defaultProductCode = this.warehouse.detail.defaultProductCode;
      this.editForm.defaultProductDescription = this.warehouse.detail.defaultProductDescription;
      this.editForm.allowSameDayShipments = this.warehouse.detail.allowSameDayShipments;
      this.editForm.palletExchange = this.warehouse.detail.palletExchange;
      this.editForm.releaseEmail = this.warehouse.detail.releaseEmail;
      this.editForm.etcEmail = this.warehouse.detail.etcEmail;
    },
    cancelEditSettings() {
      this.resetForm();
      this.$store.dispatch('warehouse/setEditingSettings', false);
    },
    async submitForm() {
      this.$refs.editForm.validate((valid, validationsErrors) => {
        if (valid) {
          Message.closeAll();
          const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
          this.$store
            .dispatch('warehouse/updateWarehouseSettings', this.editForm)
            .then((response) => {
              loading.close();
              this.$store.dispatch('warehouse/setEditingSettings', false);
              this.$message.success(response.message);
            })
            .catch(() => {
              loading.close();
            });
        } else {
          let errorMessage = '';
          Object.keys(validationsErrors).forEach((key) => {
            validationsErrors[key].forEach((validation) => {
              errorMessage += `${validation.message}. `;
            });
          });
          this.$message.warning(errorMessage);
        }
      });
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.warehouse-general-settings-label {
  .el-form-item__label {
    line-height: 1.15;
  }
}
.reverse-form-actions {
  margin-bottom: 18px;
}
</style>
